import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/Features/IR_LEDs/SuccessBox';
import IRTable from 'components/Web_User_Interface/1080p_Series/Features/IR_LEDs/irTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  IRTable,
  BreadCrumbs,
  SEOHelmet,
  React
};